import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../environments/environment';
import { User } from '../_models';
 
//import { User } from '../user.model';

import { AuthService } from '../auth.service';
import { Auth } from '../user.model';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {
 
    apiUrl =  environment.apiUrl;// "https://localhost:44318/api";
    constructor(private http: HttpClient, private authService: AuthService) {
  
    } 

    login(username: string, password: string) {
        

        const body: Auth = {
            UserName: username,
            Password: password
          }
 


        return this.http.post<any>(`${this.apiUrl}users/authenticate`, body)
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user && user.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                     this.authService.login(user) 
                }

                return user;
            }));
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser'); 
    }

    forgotPassword(email:string) {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser'); 
    }
}